import ajax from '@/libs/api.request'
export default {
  getPresentTaskList:param=>{
    return ajax.post('edu/web/task/getPresentTaskList',param);
  },
  applyPresent:param=>{
    return ajax.post('edu/web/task/applyPresent',param);
  },
  verifyPresent:param=>{
    return ajax.post('edu/web/task/verifyPresent',param);
  },
}
